module.exports = __webpack_public_path__ + "img/scene-scenic.d213da16.jpg";